import "./GradientHeader.css";

function GradientHeader({ height = "240px", image = "/gradient-bg.png" }) {
  return (
    <div
      className="gradient-header"
      style={{
        backgroundImage: `url(${image})`,
        height: height,
      }}
    />
  );
}

export default GradientHeader;